export class S3Buckets {
  static s3staticfiles = 's3staticfiles';
  static blogLaunchSites = 'blog_launch_sites';
  static queuedForResize = 'queued-for-resize';
}